import { PersistentCartPaymentOptions as Treatment } from "./ExperimentLegalAgreements/PersistentCartPaymentOptions";
import { PersistentCartPaymentOptions as Control } from "./PersistentCartPaymentOptions";
import type { PersistentCartPaymentOptionsProps } from "./PersistentCartPaymentOptions";

export const PersistentCartPaymentOptions = (
  props: PersistentCartPaymentOptionsProps,
) => {
  if (props.legalAgreementsExperimentEnabled) {
    return <Treatment {...props} />;
  }
  return <Control {...props} />;
};
